//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[[0,"Classification",1,0],[0,"Csys",1,"CartesianCoordinateSystem",0],[0,"Name",1,0]],[[[],"CreateDefaultCsys",{R_:{csys:"CartesianCoordinateSystem"}},0,0],[[],"CreateTooltipCsys",{R_:{csys:"CartesianCoordinateSystem"}},0,0],[[],"IsMachineZero",{R_:{result:''}},0,0],[[],"IsToolMount",{R_:{result:''}},0,0],[[],"IsToolTip",{R_:{result:''}},0,0]],[]];
SPLM.SIM.KinematicJunctionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.KinematicJunctionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SIM.KinematicJunctionBuilder.SystemClass = Object.freeze({
    "None" : "None", "Mount" : "Mount", "MachineZero" : "MachineZero", "ToolZero" : "ToolZero", "ToolTip" : "ToolTip", "LatheWpZx" : "LatheWpZx", "LatheWpXy" : "LatheWpXy", "RobotBase" : "RobotBase", "RobotFlange" : "RobotFlange", "PositionerBase" : "PositionerBase", "PositionerTool" : "PositionerTool"});

export default SPLM;